module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg37.057e82ce.jpg";